import { cpf } from 'cpf-cnpj-validator';
import { MoipValidator } from 'moip-sdk-js';
import get from 'lodash/get';

import { formatDateConverter } from 'src/legacy/Utils/Conversor';

import { useEventContext } from '../../provider';

import { InvalidFieldName, useCheckoutFormValuesStore } from '../../stores';
import useCellphoneValidation from '../hooks/useCellphoneValidate';

const requiredAddCardFormFields: InvalidFieldName[] = [
  'payerName',
  'payerCpf',
  'payerBirthdate',
  'payerPhone',
  'payerZipCode',
  'payerAddress',
  'payerDistrict',
  'payerState',
  'payerCity',
  'cardNumber',
  'cardCvc',
  'cardExpiration',
];

const getExpiryPair = (expiration: string) => {
  const separated_terms = expiration.split(' / ');

  return {
    expirationMonth: separated_terms[0].trim(),
    expirationYear: separated_terms[1]
      ? separated_terms[1].trim().slice(-2)
      : '',
  };
};

export const useAddCardForm = () => {
  const { formValues } = useCheckoutFormValuesStore();
  const { setInvalidFieldsNames, setInvalidFieldsMessage } = useEventContext();
  const isValidPhone = useCellphoneValidation()


  const trigger = () => {
    const invalidFieldsNames: InvalidFieldName[] = [];
    const invalidFieldsMessage = [];

    requiredAddCardFormFields.forEach(fieldName => {
      if (['', undefined].includes(get(formValues, fieldName))) {
        invalidFieldsNames.push(fieldName);
        invalidFieldsMessage.push('Preencha todos os campos');
      }
    });

    if (
      !MoipValidator.isSecurityCodeValid(
        formValues.cardNumber.replace(/\s/g, ''),
        formValues.cardCvc,
      )
    ) {
      invalidFieldsNames.push('cardCvc');
      invalidFieldsMessage.push('O código de segurança está incorreto');
    }

    if (
      !MoipValidator.isExpiryDateValid(
        getExpiryPair(formValues.cardExpiration).expirationMonth,
        getExpiryPair(formValues.cardExpiration).expirationYear,
      )
    ) {
      invalidFieldsNames.push('cardExpiration');
      invalidFieldsMessage.push('A validade está incorreta');
    }

    if (!MoipValidator.isValidNumber(formValues.cardNumber)) {
      invalidFieldsNames.push('cardNumber');
      invalidFieldsMessage.push('O número do cartão não é válido');
    }

    if (!isValidPhone(formValues.payerPhone)) {
      invalidFieldsNames.push('payerPhone');
      invalidFieldsMessage.push('Telefone inválido');
    }

    if (formValues.payerCity === '') {
      invalidFieldsNames.push('payerZipCode');
      invalidFieldsMessage.push('Cep inválido');
    }

    if (formValues.payerName.length < 3 || formValues.payerName.length > 65) {
      invalidFieldsNames.push('payerName');
      invalidFieldsMessage.push(
        'O nome do titular deve ter entre 3 e 65 letras',
      );
    }

    if (!cpf.isValid(formValues.payerCpf)) {
      invalidFieldsNames.push('payerCpf');
      invalidFieldsMessage.push('CPF inválido');
    }

    const birthDate = new Date(formatDateConverter(formValues.payerBirthdate));
    if (
      !formValues.payerBirthdate
        .replace(/\s/g, '')
        .match(/^\d{2}[.//]\d{2}[.//]\d{4}$/) ||
      birthDate > new Date() ||
      birthDate <
        new Date(new Date().setFullYear(new Date().getFullYear() - 120)) ||
      !birthDate
    ) {
      invalidFieldsNames.push('payerBirthdate');
      invalidFieldsMessage.push('Data de nascimento inválida');
    }

    setInvalidFieldsNames?.(invalidFieldsNames);
    setInvalidFieldsMessage?.(invalidFieldsMessage);
    return invalidFieldsNames.length === 0;
  };

  return { trigger, values: formValues };
};
